import styled from 'styled-components';

export const Footer = styled.div`
  padding: 0 20px 32px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
`;
